import React, { useState, useRef } from 'react'
import { FaChevronDown } from 'react-icons/fa'

export default function LibraryPlayerPicker({ players, onAdd }) {
	const [input, setInput] = useState('')
	const [showSuggestions, setShowSuggestions] = useState(false)
	const elRef = useRef()

	const lowerInput = input.toLowerCase()
	const matching = players
		? players.filter((p) => p.name.toLowerCase().includes(lowerInput))
		: []
	const nonMatching = players
		? players.filter((p) => !matching.includes(p))
		: []

	function commitAdd(player) {
		onAdd(player)
		setInput('')
		setShowSuggestions(false)
	}

	function handleInputChange(e) {
		setInput(e.target.value)
		setShowSuggestions(true)
	}

	function handleInputClick() {
		setShowSuggestions(true)
	}

	function handleChevronClick() {
		setShowSuggestions((prev) => !prev)
	}

	function handleBlur() {
		if (elRef.current && !elRef.current.contains(document.activeElement)) {
			setShowSuggestions(false)
		}
	}

	function handleKeyDown(e) {
		if (e.key === 'Escape') {
			setShowSuggestions(false)
		} else if (e.key === 'Enter') {
			e.preventDefault()
			if (matching[0]) commitAdd(matching[0])
		}
	}

	return (
		<div className="relative" ref={elRef}>
			<div className="flex relative w-56">
				<input
					className="rounded-r-none flex-grow"
					type="text"
					value={input}
					onChange={handleInputChange}
					onClick={handleInputClick}
					onBlur={handleBlur}
					onKeyDown={handleKeyDown}
					placeholder="Search library…"
					autoComplete="off"
				/>
				<button
					type="button"
					className="flex items-center px-2 text-gray-400 hover:text-gray-200 rounded-l-none"
					onClick={handleChevronClick}
					onBlur={handleBlur}
					tabIndex={-1}
				>
					<FaChevronDown />
				</button>
			</div>

			{showSuggestions && (
				<ul className="absolute z-10 bg-white border border-gray-300 w-56 max-h-60 overflow-y-auto">
					{matching.map((p) => (
						<li
							key={p.name}
							className="p-1 cursor-pointer hover:bg-gray-400"
							onMouseDown={(e) => {
								e.preventDefault()
								commitAdd(p)
							}}
							tabIndex="0"
						>
							<span className="font-medium">{p.name}</span>
						</li>
					))}
					{nonMatching.map((p) => (
						<li
							key={p.name}
							className="p-1 cursor-pointer hover:bg-gray-200 text-gray-400"
							onMouseDown={(e) => {
								e.preventDefault()
								commitAdd(p)
							}}
							tabIndex="0"
						>
							<span>{p.name}</span>
							{p.country && (
								<span className="text-xs ml-1">
									{p.country.toUpperCase()}
								</span>
							)}
						</li>
					))}
				</ul>
			)}
		</div>
	)
}
